import VMasker from 'vanilla-masker';

// Script para lidar com o evento de clique no botao flutuante de contato
const modalContactListener = () => {
	const btnToggle = document.querySelector("#btn-modal-contact");

	if (btnToggle !== null) {
		btnToggle.addEventListener("click", () => {
			const modalContainer = document.querySelector("#modal-container");
			let suboriginModal = document.querySelector("#modal-container input[name='00N5Y00000RVt8Z']");

			if (modalContainer !== null) {
				modalContainer.classList.toggle("close");
			} else {
				const modalContainerClass = document.querySelector('.modal-container');
				suboriginModal = document.querySelector(".modal-container input[name='00N5Y00000RVt8Z']");
				if (modalContainerClass !== null) {
					modalContainerClass.classList.toggle("close");
				}
			}

			suboriginModal.value += ' - Ícone flutuante';
		});
		btnToggle.classList.remove('close');
	}
	const transferToWhats = document.querySelectorAll('.transferClickToWhatsappRD');
	if (transferToWhats !== null) {
		transferToWhats.forEach((button, index) => {
			button.addEventListener('click', () => {
				const modalContainer = document.querySelector("#modal-container");
				let suboriginModal = document.querySelector("#modal-container input[name='00N5Y00000RVt8Z']");
				let txtButton = button.querySelector('span.elementor-button-text').textContent;
				if (modalContainer !== null) {
					modalContainer.classList.toggle("close");
				} else {
					const modalContainerClass = document.querySelector('.modal-container');
					suboriginModal = document.querySelector(".modal-container input[name='00N5Y00000RVt8Z']");
					if (modalContainerClass !== null) {
						modalContainerClass.classList.toggle("close");
					}
				}

				if (txtButton) {
					suboriginModal.value += ' -  Botão ' + txtButton.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase());
				} else {
					if (index == 0) {
						suboriginModal.value += ' -  Botão Fale com um consultor';
					} else if (index == 1) {
						suboriginModal.value += ' - Botão Quero ser convencido';
					}
				}
			})
		})
	}
	const closeButton = document.querySelector('#close-modal-btn i');
	if (closeButton !== null) {
		closeButton.addEventListener("click", () => {
			const modalContainer = document.querySelector("#modal-container");
			if (modalContainer !== null) {
				modalContainer.classList.toggle("close");
			} else {
				const modalContainerClass = document.querySelector('.modal-container');
				if (modalContainerClass !== null) {
					modalContainerClass.classList.toggle("close");
				}
			}
		});
	}
};

// Adiciona listener aos botões que controlam o que é exibido no modal
const modalClickListener = (element) => {
	const button = document.querySelector(`${element}`);
	if (!button) {
		return;
	}

	button.addEventListener("click", () => {
		const modalWhatsappOptions = document.querySelector('.whatsapp-modal-options');
		modalWhatsappOptions.classList.toggle("hidden");
	})
}

//Preenche os inputs escondidos firt_name e last_name ao preencher o field Nome
const handleFirstNameChange = (form) => {
	const formSelected = document.querySelector(`.${form}`);
	if (formSelected !== null) {
		const inputName = formSelected.querySelector("#form-name");
		if (inputName !== null) {
			let originalInput = "";
			let str = [];
			const firstName = formSelected.querySelector('#first_name');
			const lastName = formSelected.querySelector("#last_name");
			inputName.addEventListener("input", ({ target }) => {
				originalInput = target.value;
				str = originalInput.split(" ");
			});
			inputName.addEventListener("blur", () => {
				const firstElement = str.shift();
				firstName.value = firstElement;
				const lastNameJoined = str.join(' ');
				lastName.value = lastNameJoined;
			});
		}
	}
};

const addMaskToPhoneInputs = () => {
	VMasker(document.querySelectorAll("input.mobile")).maskPattern("(99) 99999-9999");

	//Aplica mascara para o campo phone do formulario do HSM
	const inputPhoneSelector = ".bricks-form__input.phone";
	VMasker(document.querySelectorAll(inputPhoneSelector)).maskPattern("(99) 99999-9999"); //FORM HSMU
	jQuery(inputPhoneSelector).focusout(() => {
		VMasker(document.querySelectorAll(inputPhoneSelector)).maskPattern("(99) 99999-9999"); //FORM HSMU
	})
}

const changeLabelText = (selector, string) => {
	const element = document.querySelector(selector);
	if (element !== null) {
		element.innerText = string;
	}
}

// Valida inputs dos formulários
function validateInputField() {
	const fields = document.querySelectorAll("[required]")

	function ValidateField(field) {

		function verifyMobile(value) {
			const regex = /(\d)\1{10}/g;
			const regexNumber = /[0-9]{2}9[0-9]{4}[0-9]{4}/;

			if (regex.test(value.replace(/\D/g, '')) || (!regexNumber.test(value.replace(/\D/g, ''))) || (value < 11)) {
				return 'typeMismatch';
			}
			return false;

		}

		// verifica se existem erros nos campos
		function verifyErrors() {
			let foundError = false;


			if (field.getAttribute('name') == 'mobile') {
				return verifyMobile(field.value);

			}

			for (let error in field.validity) {
				if (field.validity[error] && !field.validity.valid) {
					foundError = error
				}
			}
			return foundError;
		}

		function customMessage(typeError) {
			const messages = {
				text: {
					valueMissing: "Esse campo é obrigatório",
					typeMismatch: "Número de celular inválido"
				},
				email: {
					valueMissing: "Esse campo é obrigatório",
					typeMismatch: "Endereço de email inválido",
					patternMismatch: "Endereço de email inválido"
				}
			}

			return messages[field.type][typeError]
		}

		// aplica mensagem de erro
		function setCustomMessage(message) {
			const spanError = field.parentNode.querySelector("span.error")

			if (message) {
				spanError.innerHTML = message
			} else {
				spanError.innerHTML = ""
			}

		}

		return function () {
			const error = verifyErrors()

			if (error) {
				const message = customMessage(error)

				field.style.borderColor = "red"
				setCustomMessage(message)
			} else {
				field.style.borderColor = "unset"
				setCustomMessage()
			}
		}
	}

	function customValidation(event) {
		const field = event.target
		const validation = ValidateField(field)

		validation()
	}

	for (let field of fields) {
		field.addEventListener("invalid", event => {
			event.preventDefault()
			customValidation(event)
		})
		field.addEventListener("blur", customValidation)
	}
}

/* Invalida o campo mobile caso todos os 11 dígitos sejam iguais, se possui menos que 11 digitos e se ele possui o digito 9 após o DDD*/
function invalidateMobileField() {
	const mobileFields = document.querySelectorAll("input.mobile");
	const submitButtons = document.querySelectorAll(".submit.wl-form-button");
	const btnRDSubmit = document.querySelector("#rd-button-kkpl8ybq"); //Botão do formulario do HSM

	mobileFields.forEach(
		mobileField => {
			mobileField.addEventListener("keyup", () => {
				const regex = /(\d)\1{10}/g;
				const regexNumber = /[0-9]{2}9[0-9]{4}[0-9]{4}/;

				if (regex.test(mobileField.value.replace(/\D/g, '')) || (!regexNumber.test(mobileField.value.replace(/\D/g, ''))) || (mobileField.value < 11)) {
					mobileField.nextElementSibling.innerText = "Número de celular inválido";
					mobileField.style.borderColor = "red";
					submitButtons.forEach(submitButton => {
						submitButton.style.opacity = "0.45"
						submitButton.disabled = true;
					})

					btnRDSubmit.style.opacity = "0.45"
					btnRDSubmit.disabled = true;

				}
				else {
					mobileField.nextElementSibling.innerText = "";
					mobileField.style.borderColor = "unset";
					submitButtons.forEach(submitButton => {
						submitButton.style.opacity = "1"
						submitButton.disabled = false;
					})

					btnRDSubmit.style.opacity = "1";
					btnRDSubmit.disabled = false;
				}
			})
		}
	)
}

invalidateMobileField();

//Exclusivo apenas para um formulario do HSM
const errorMessagePhone = () => {
	const btnRDSubmit = document.querySelector("#rd-button-kkpl8ybq");
	const groupInputPhone = document.querySelector(".phone-input-group");
	if (groupInputPhone) {
		const inputPhoneSelector = groupInputPhone.querySelector(".bricks-form__input.phone");
		inputPhoneSelector.dataset.inputMask = "MASK";

		inputPhoneSelector.classList.add('mobile');
		groupInputPhone.innerHTML = inputPhoneSelector.outerHTML;
		groupInputPhone.innerHTML += `<span class="error" style="display:block; margin:0 auto; font-size:12px; line-height:1.1; color:#DC3543; padding: 2px 0 0 4px"></span>`;
	}

}

function webToLeadOnSubmit(e) {
	const form = e.target
	function validate() {
		const mobileField = form.querySelector('#mobile')
		const isHidden = window.getComputedStyle(mobileField).display === 'none'
		if (isHidden) return true
		const mobileFieldValue = mobileField.value
		if (mobileFieldValue.length !== 15) {
			form.querySelector('#mobile').nextElementSibling.innerText = "Número de celular inválido"
			return false
		}
		return true
	}
	const isValid = validate()
	if (!isValid) return false
	return true
}

function webToLeadAddSubmitListener() {
	const formsWebToLead = Array.from(document.querySelectorAll('.form-web-to-lead'))
	formsWebToLead.forEach((form) => {
		form.onsubmit = webToLeadOnSubmit

	})
}

validateInputField();

const setActiontoWhatsappBanner = () => {
	const bannerWhatsapp = document.querySelector('[data-cta-title="Convide um amigo"]');

	if (bannerWhatsapp !== null) {
		bannerWhatsapp.removeAttribute('href')
		bannerWhatsapp.removeAttribute('target')
		bannerWhatsapp.style.cursor = "pointer"
	}

	jQuery(bannerWhatsapp).on('click', function () {
		elementorProFrontend.modules.popup.showPopup({ id: 129065 })
		elementorProFrontend.modules.popup.showPopup({ id: 229642 })
		elementorProFrontend.modules.popup.showPopup({ id: 139386 })
		elementorProFrontend.modules.popup.showPopup({ id: 233459 })
	})
}
setActiontoWhatsappBanner()

jQuery(document).on('elementor/popup/show', () => {
	addMaskToPhoneInputs();
	validateInputField();
	invalidateMobileField();

});

window.onload = () => {

	modalContactListener();
	errorMessagePhone();
	modalClickListener('#btn-adquirir-cursos');
	modalClickListener('#modal-back');
	handleFirstNameChange('hsmu-form-rodape');
	handleFirstNameChange('hsmu-form-whats');
	handleFirstNameChange('hsmu-form-duvidas');
	handleFirstNameChange('hsmu-form-ebook');
	handleFirstNameChange('hsmu-form-code');
	handleFirstNameChange('hsmu-form-bolsa');
	handleFirstNameChange('hsmu-form-tv');
	handleFirstNameChange('form-lead');
	addMaskToPhoneInputs();
	changeLabelText('.ebradi-form-juridiques .area-ebradi.wl-form-label', 'Quais assuntos você gostaria de acompanhar no Sem Juridiquês?');
	webToLeadAddSubmitListener();
	invalidateMobileField();

};
